const getLocaleFromLocalizedUrl = (url: string) => {
  const urlParts = url.split('/').filter(v => Boolean(v))

  return urlParts[0] || ''
}

export default getLocaleFromLocalizedUrl
